import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { DataService } from './../../Service/data.service';
import { ConfirmDialogService } from 'src/app/adminUsers/confirm-dialog/confirm-dialog.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-subscriber-header',
  templateUrl: './subscriber-header.component.html',
  styleUrls: ['./subscriber-header.component.scss']
})
export class SubscriberHeaderComponent implements OnInit {

  constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public injector: Injector, private route: Router, private DataServiceObj: DataService, private confirmDialogService: ConfirmDialogService, private ngxLoader: NgxUiLoaderService) {

    // show only a few items on demo
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
    this.DataServiceObj.title.subscribe(updatedTitle => {
      this.length = updatedTitle;
    });
    // Re-fetch the greeting after a profile edit; only a directly signed-in subscriber
    // (token present) is greeted from their own profile.
    this.DataServiceObj.profileUpdated.subscribe(() => {
      const sessionData = JSON.parse(sessionStorage.getItem('subscriberLogin') || 'null');
      if (sessionData?.token) {
        this.getProfileDetails(sessionData);
      }
    });
  }

  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  router: Router;
  role: any;
  companyName: any;
  userProfileData: any;

  isNavSearchVisible: boolean;
  @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button
  response: any;
  Alerts: any[];
  length: any;
  userFirstName: any;

  get fullName(): string {
    if (this.userProfileData && this.userProfileData[0]) {
      const full = this.buildName(this.userProfileData[0].firstname, this.userProfileData[0].lastname);
      if (full) return full;
    }
    const adminSession = JSON.parse(sessionStorage.getItem('userLogin') || 'null');
    if (adminSession?.Data?.firstname || adminSession?.Data?.lastname) {
      const afull = this.buildName(adminSession.Data.firstname, adminSession.Data.lastname);
      if (afull) return afull;
    }
    return this.userFirstName || 'User';
  }

  // "First Last" when both are present and different; otherwise only the first name
  // (avoids "Cruz Cruz" when lastname is empty or repeats the first name).
  private buildName(firstname: string, lastname: string): string {
    const f = (firstname || '').trim();
    const l = (lastname || '').trim();
    if (!f) return l;
    if (!l || f.toLowerCase() === l.toLowerCase() || f.toLowerCase().endsWith(' ' + l.toLowerCase())) {
      return f;
    }
    return `${f} ${l}`;
  }

  get userInitials(): string {
    const name = this.fullName;
    if (!name) return 'U';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  openOrderReport(): void {
    this.route.navigate(['/subscriber-reports/report-list'], {
      queryParams: { openOrderModal: 'true', t: Date.now() }
    });
  }

  ngOnInit() {
    this.isNavSearchVisible = false;
    // var clicks = JSON.parse(sessionStorage.getItem('userLogin'));

    if (sessionStorage.getItem('subscriberLogin')) {
      const sessionData = JSON.parse(sessionStorage.getItem('subscriberLogin'));
      this.role = sessionData.Data.role;
      this.companyName = sessionData.companyName;
      console.log('sessionData******123', sessionData);
      this.getNotigication();

      // Who is greeted depends on WHO is driving the session, while the "Subscriber:"
      // banner always names the subscriber being viewed:
      //   - subscriber signs in directly (token present) -> greet that user, resolved
      //     from their own txnUsers row.
      //   - admin switches into a subscriber (no token; Data is a subscriber record)
      //     -> keep the subscriber's company in the banner but greet the ADMIN, whose
      //     identity lives in the separate `userLogin` session entry. Calling
      //     getProfileDetails here would look the id up in txnUsers and greet an
      //     unrelated subscriber user.
      if (sessionData.token) {
        this.getProfileDetails(sessionData);
      } else {
        const adminSession = JSON.parse(sessionStorage.getItem('userLogin') || 'null');
        this.userFirstName = adminSession?.Data?.firstname || '';
      }
      if (this.companyName == undefined)
      {
        // Data.id is the txnUsers row id; the subscriber id is Data.subscriberId. Passing
        // Data.id here looked up whichever txnSubscribers row happens to share that
        // number, so the "Subscriber:" banner showed a different company entirely —
        // e.g. user 10 (subscriber 9, Windsor) was labelled subscriber 10, Gambone.
        // The two id sequences are offset, so nearly every account was mislabelled.
        // An admin impersonating a subscriber stores a subscriber record (no
        // subscriberId field) and carries no token, so it still falls back to Data.id.
        this.getSubscriberDetails(sessionData.token ? sessionData.Data.subscriberId : sessionData.Data.id);

      }
    } else {
      const sessionData = JSON.parse(sessionStorage.getItem('userLogin'));
      this.role = '';
      this.companyName = '';
    }

    const ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
      this.fsbutton.nativeElement.style.display = 'none';
    }

    this.router = this.injector.get(Router);

    // Autoclose navbar on mobile when route change
    this.router.events.subscribe((val) => {
      // scroll view to top
      window.scrollTo(0, 0);
      // close collapse menu
      this.navCollapsed = true;
    });

  }
  getSubscriberDetails(id) {
    const userToken = this.DataServiceObj.getUserToken();
    const data = {
      subscriberId: id
    };

    this.DataServiceObj.getDvId('admin/user/getSubscriberData', data, userToken).subscribe((res: any) => {
      console.log('testoneCompany nameeeee', res);
      this.response = res;
      if (res.Status == 200)
      {
        if (res.Data.length != 0)
          {
            this.companyName = res.Data[0]?.companyName;
            // Deliberately does NOT set role = 'admin'. This method only resolves a
            // company name for the banner, and it runs whenever the session has no
            // cached companyName — which is exactly the case for a normal subscriber
            // signing in. Setting the admin role here granted every subscriber the
            // admin-only "Switch to Admin" control in the header.
            //
            // The admin role comes solely from the session: subscriberSwitch() stores
            // Data.role = 'admin' when an admin switches into a subscriber, and that is
            // read into this.role in ngOnInit.
          }
      }

      console.log('testoneCompany nameeeee', this.companyName);

  }, err => {

  });
  }
  getProfileDetails(sessionData) {
    const userToken = this.DataServiceObj.getUserToken();
    this.DataServiceObj.getSubscriberDetailsByID('admin/user/getSubscriberDetailsByID', sessionData, userToken).subscribe(res => {
      this.response = res;
      this.userProfileData = this.response.Data;
      console.log('this.userProfileData***', this.userProfileData);
      this.userFirstName = this.userProfileData[0].firstname;
    },
      err => {

      });
  }

  toggleUserBlock(event) {
    event.preventDefault();
    this.userblockService.toggleVisibility();
  }

  openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setNavSearchVisible(stat: boolean) {
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  toggleOffsidebar() {
    this.settings.toggleLayoutSetting('offsidebarOpen');
  }

  toggleCollapsedSideabar() {
    this.settings.toggleLayoutSetting('isCollapsed');
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  toggleFullScreen(event) {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  navigateTo2StepAuth() {
    //  this.route.navigate(['/twoFaAuth']);
    this.router.navigate(['/subscriber_edit_profile']);

    // window.scrollTo(0, 0);
  }

  subscriberLogout() {
    const obj = this;
    this.confirmDialogService.confirmThis('Are you sure to logout?', function() {
      sessionStorage.clear();
      obj.DataServiceObj.RemoveUserToken();
      obj.route.navigate(['/login']);
    }, function() {
    });
  }

  switchAdmin() {
    const obj = this;
    this.confirmDialogService.confirmThis('Are you sure you want to switch?', function() {
      obj.router.navigate(['/home']);

      obj.ngxLoader.start();
      sessionStorage.removeItem('subscriberLogin');
      console.log('we');
      // obj.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        // obj.router.navigate(['/home'])
      // window.location.reload();
      setTimeout(() => {
      window.location.reload();
      obj.ngxLoader.stop()
        ;
    }, 1000);

      // obj.ngxLoader.stop();

    }, function() {
    });
  }

  subscriberEditProfile() {
    this.router.navigate(['/subscriber_edit_profile']);
  }

  subscriberNotifictaion() {
    this.router.navigate(['/alert-notification']);
  }

  getNotigication() {
    const userToken = this.DataServiceObj.getUserToken();
    const clicks = JSON.parse(sessionStorage.getItem('subscriberLogin'));

    const data = {
      id: clicks.Data.id
    };
    this.DataServiceObj.getUserData('admin/alertsAnnouncements/getUnReadAlertsDetailsBySubscriberId', data, userToken).subscribe((res: any) => {
      this.response = res;
      // this.Alerts=res.Data;
      if (res.Data != null) {
        const Alerts = res.Data.filter(v => v.isDeleted == 0);
        const AlertsData = res.Data.filter(v => v.isDeleted == 0);
        for (let i = 0; i < Alerts.length; i++) {
          const ids = Alerts[i].subscribersId.split(',');
          AlertsData[i].subscribersId = ids;
        }
        const id = '' + clicks.Data.id;
        this.Alerts = [];
        for (let i = 0; i < AlertsData.length; i++) {

          if (AlertsData[i].subscribersId.length > 0) {
            if (AlertsData[i].subscribersId.includes(id)) {
              this.Alerts.push(AlertsData[i]);
            }
          }
        }
        this.length = this.Alerts.length;
      } else {
        this.length = 0;
      }

    },
      err => {

      });
  }
}
